import React from 'react'
import calculatorBlue from '../../Assets/Images/Home/calculadora.svg'
import CalculatorProcess from '../CalculatorProcess'
import { t } from 'i18next'
import { MATERIALS_CALCULATOR_CEILING_PARAM, ROUTES } from 'Utils/constants'
import { useHistory } from 'react-router-dom'

function FloatingCalculator({ setChangeModal, calcType, setCalcType }) {
  const history = useHistory()
  const handleCalcAction = newCalc => {
    setCalcType(newCalc)
    setChangeModal(true)
  }

  return (
    <>
      {!calcType ? (
        <>
          <div
            className="modal-calculadora-options"
            data-testid="container-floating-calculator">
            <div
              className="calculator-option"
              onClick={() =>
                history.push(
                  `${ROUTES.materialsCalculator}?${MATERIALS_CALCULATOR_CEILING_PARAM}`
                )
              }
              data-testid="btn-calculator-roof-materials">
              <img src={calculatorBlue} alt="calculadora" />
              <h2>{t('MODAL_CALCULATOR_T.CALCULATE_ROOF_MATERIALS_TITLE')}</h2>
            </div>
            <div
              className="calculator-option"
              onClick={() => handleCalcAction('pvc')}
              data-testid="btn-calculator-pvc-roof">
              <img src={calculatorBlue} alt="calculadora" />
              <h2>{t('MODAL_CALCULATOR_T.CALCULATE_PVC_ROOF_TITLE')}</h2>
            </div>
            <div
              className="calculator-option"
              onClick={() => handleCalcAction('paredGypsum')}
              data-testid="btn-calculator-gypsum-wall">
              <img src={calculatorBlue} alt="calculadora" />
              <h2>{t('MODAL_CALCULATOR_T.CALCULATE_GYPSUM_WALL_TITLE')}</h2>
            </div>
            <div
              className="calculator-option"
              onClick={() => handleCalcAction('techoGypsum')}
              data-testid="btn-calculator-gypsum-roof">
              <img src={calculatorBlue} alt="calculadora" />
              <h2>{t('MODAL_CALCULATOR_T.CALCULATE_GYPSUM_ROOF_TITLE')}</h2>
            </div>
          </div>
        </>
      ) : (
        <CalculatorProcess
          calcType={calcType}
          setCalcType={setCalcType}
          setChangeModal={setChangeModal}
        />
      )}
    </>
  )
}

export default FloatingCalculator
